<div style="background: white; border: 1px solid #e5e7eb; border-radius: 14px; padding: 16px 20px; transition: border-color 0.2s ease;"
  onmouseover="this.style.borderColor='#34d399'" onmouseout="this.style.borderColor='#e5e7eb'">
  <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 12px;">
    <div style="display: flex; align-items: center; gap: 10px;">
      <div style="background: #f0fdf4; border: 1px solid #bbf7d0; border-radius: 10px; padding: 8px; display: flex; align-items: center; justify-content: center;">
        <mat-icon style="font-size: 20px; width: 20px; height: 20px; color: #1C593D;">account_balance</mat-icon>
      </div>
      <span style="font-size: 0.95rem; font-weight: 700; color: #1e5a3f;">{{cuenta?.alias}}</span>
    </div>
    <button type="button" [matMenuTriggerFor]="menu"
      style="display: inline-flex; align-items: center; justify-content: center; width: 36px; height: 36px; border: 1px solid #e5e7eb; border-radius: 8px; background: white; cursor: pointer; transition: all 0.2s ease;"
      onmouseover="this.style.background='#f0fdf4'; this.style.borderColor='#34d399'" onmouseout="this.style.background='white'; this.style.borderColor='#e5e7eb'">
      <mat-icon style="font-size: 20px; width: 20px; height: 20px; color: #374151;">more_vert</mat-icon>
    </button>
    <mat-menu #menu="matMenu">
      <button mat-menu-item (click)="actualizar()">
        <mat-icon>edit</mat-icon>
        <span>Editar</span>
      </button>
      <button mat-menu-item (click)="inactivarCuenta()">
        <mat-icon>delete</mat-icon>
        <span>Eliminar</span>
      </button>
    </mat-menu>
  </div>

  <div class="grid grid-cols-1 sm:grid-cols-3 gap-2">
    <div>
      <span style="font-size: 0.7rem; font-weight: 600; color: #6b7280; text-transform: uppercase;">Banco</span>
      <p style="font-size: 0.85rem; font-weight: 600; color: #374151; margin: 2px 0 0;">{{cuenta?.banco}}</p>
    </div>
    <div>
      <span style="font-size: 0.7rem; font-weight: 600; color: #6b7280; text-transform: uppercase;">Tipo Cuenta</span>
      <p style="font-size: 0.85rem; font-weight: 600; color: #374151; margin: 2px 0 0;">{{cuenta?.tipoCuenta}}</p>
    </div>
    <div>
      <span style="font-size: 0.7rem; font-weight: 600; color: #6b7280; text-transform: uppercase;">Número de cuenta</span>
      <p style="font-size: 0.85rem; font-weight: 600; color: #1e5a3f; font-family: 'Courier New', monospace; margin: 2px 0 0;">{{cuenta?.numeroCuenta}}</p>
    </div>
  </div>
</div>
